/* eslint-disable
    import/no-unresolved,
    no-param-reassign,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./conversation.scss');
require('angular-elastic');

const deps = [
  require('data/model/conversation').name,
  require('data/collection/conversation').name,
  require('data/collection/conversationSummary').name,
  require('ui/web/comment').name,
  require('data/date').name,
  'monospaced.elastic',
];

module.exports = angular
  .module('bench.component.conversation', deps)

  .directive('blConversation', ($timeout, $window) => ({
    restrict: 'E',
    scope: {
      // if no conversation id is provided, the user will be prompted
      // to create a new one, in which case the attachedTo value
      // will need to be specified.
      conversationId: '=',
      clientId: '=',
      attachedTo: '=',
      newConversationMessage: '@',
      commentReplyMessage: '@',
    },
    bindToController: true,
    template: require('./conversation.html'),
    controller: require('./conversationCtrl.js'),
    controllerAs: 'vm',
    link(scope, elem, attrs) {
      const footer = elem.find('.reply-box');
      const conversation = elem.find('.comment-list');

      const resizeConversation = () => conversation.height(elem.height() - footer.outerHeight());

      $window.onresize = resizeConversation;

      scope.$watch(() => footer.outerHeight(), resizeConversation);

      const scrollToBottom = () =>
        $timeout(() => conversation.scrollTop(conversation[0].scrollHeight));
      scope.$watch('vm.conversationId', scrollToBottom);
      return scope.$watch('vm.conversationVM.comments.length', scrollToBottom);
    },
  }));
